export * as accordionStyleConfigs from './style-configs';

export { Accordion } from './accordion';
export type { AccordionProps } from './types';
